<template>
  <div>
    <el-button
      v-if="netFlows.length"
      icon="el-icon-view"
      @click="dialogVisible = true"
      >查看区间内净流入/流出</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="净流入/流出记录"
      width="1000px"
      @close="closeDialog"
    >
      <el-table :data="netFlows">
        <el-table-column label="时间">
          <template slot-scope="scope">
            <span>{{ scope.row.businessTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="coinType" label="币种"></el-table-column>
        <el-table-column label="方向">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.amount > 0" type="success">流入</el-tag>
            <el-tag v-else type="danger">流出</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="数量">
          <template slot-scope="scope">
            {{ Math.abs(scope.row.amount) }}
          </template>
        </el-table-column>
        <el-table-column prop="userId" label="用户ID"></el-table-column>
        <el-table-column align="right" label="操作">
          <template slot-scope="scope">
            <el-button
              circle
              icon="el-icon-delete"
              :loading="scope.row.id === submitting"
              type="danger"
              @click="submit(scope.row.id)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "FlowList",
  data() {
    return {
      dialogVisible: false,
      submitting: false,
    };
  },
  computed: {
    ...mapState("snapshotStatistic", ["netFlows"]),
  },
  methods: {
    ...mapActions("snapshotStatistic", ["removeFlow"]),
    closeDialog() {
      this.dialogVisible = false;
    },
    submit(id) {
      if (this.submitting) return;

      this.submitting = id;
      this.removeFlow({
        id,
      })
        .then(() => {
          this.$emit("onChange");
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
</style>
